import React, { useContext, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { Breadcrumb, Image, Toast } from "react-bootstrap";
import { get, find, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faTimesCircle,
} from "@fortawesome/pro-light-svg-icons";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { InnerLayoutButtons } from "..";
import {
  manageTransactionStore,
  setManageTransactionToastInfo,
  //setManageTradeFlow,
  //setManageTradeToastInfo,
} from "../../contexts";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import {
  ALL_MANAGE_TRADE_ROUTES,
  ALL_MANAGE_TRANSACTION_ROUTES,
  MANAGE_TRANSACTION_ROUTES,
  ROUTES,
  apiErrors,
  getPathWithParam,
  FLOW_TYPES,
} from "../../utils";
import { useFormikContext } from "formik";
import { composeSortDescriptors } from "@progress/kendo-data-query";
// import Cancel from "../../styles/cancel.png";
import RouteLeavingGuard from "../RouteLeavingGuard";

const ManageTransactionLayout = ({
  children,
  buttons = [],
  tabs,
  pageFlow,
  layoutHeader,
  customBreadCrumbs,
  history,
  blockNavigation,
  useBlockNavigationAlways = false,
}) => {
  const [showError, setShowError] = useState(false);
  const { state, dispatch } = useContext(manageTransactionStore);
  const { flow } = useRouterParams();
  const apiData = get(state, "api.data", {});
  const apiError = get(state, "api.error", {});
  const {
    showToast,
    toastMessage,
    toastMessage1,
    reject,
    toastMessage2,
  } = state;
  const {
    isSubmitting,
    dirty,
    resetForm,
    setSubmitting,
  } = useFormikContext() || { dirty: false };

  const menuDetails = find(ALL_MANAGE_TRANSACTION_ROUTES, (item) => {
    if (get(state, "selectedMenu", "").indexOf(get(item, "path")) !== -1) {
      return true;
    }
    return false;
  });

  useDeepEffect(
    () => {
      if (!isEmpty(apiError)) {
        setShowError(true);
      }
    },
    [apiError],
    true
  );

  const breadCrumOptions = [
    {
      label: "Home",
      link: ROUTES.HOME,
    },
    {
      label: "Transaction",
      link: ROUTES.TRANSACTION,
    },
  ];

  const breadCrumbsFromMenuDetails = get(menuDetails, "breadCrumbs", []);
  if (!isEmpty(customBreadCrumbs)) {
    breadCrumOptions.push(...customBreadCrumbs);
  } else if (!isEmpty(breadCrumbsFromMenuDetails)) {
    breadCrumOptions.push(
      ...breadCrumbsFromMenuDetails.map((item) => ({
        ...item,
        link: getPathWithParam({
          path: item.link,
          //pathParam: [flow, eligibilityId],
        }),
      }))
    );
  }

  const onRefresh = () => {
    if (resetForm) {
      resetForm();
      setSubmitting(false);
    }
  };

  const errorStatus = get(apiError, "response.status", 500);
  const errorData = apiErrors[errorStatus];

  return (
    <div className="d-flex flex-column manage-company h-100">
      <div className="d-flex flex-column layout-header">
        <div className="d-flex align-items-center">
          <div>
            <Breadcrumb>
              {breadCrumOptions.slice(-4).map((item, index) => (
                <Breadcrumb.Item key={index}>
                  <Link to={item.link}>{item.label}</Link>
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
            <h5>{layoutHeader || get(menuDetails, "contentHeader", "")}</h5>
          </div>
          <div className="d-flex align-items-center justify-content-center tab-wrapper">
            {tabs}
          </div>
          <div className="ml-auto">
            <InnerLayoutButtons
              menu="transaction"
              subMenu={get(menuDetails, "id", "")}
              buttonsList={buttons}
              flow={pageFlow}
            />
          </div>
          {/* {showError && (
            <div
              className={`error-banner justify-content-between d-flex align-items-center ${
                (showError && "enable") || ""
              }`}
            >
              <div>
                <Image src={Cancel} width="30px" />
              </div>
              <div>
                <div className="error-heading">{errorData.heading}</div>
                <div className="error-reason">{errorData.reason}</div>
              </div>
              <div>
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  color="#000"
                  style={{ fontSize: "14px" }}
                  onClick={() => setShowError(false)}
                />
              </div>
            </div>
          )} */}
        </div>
      </div>
      <div className="layout-content h-100 overflow-auto">{children}</div>
      <Toast
        onClose={() =>
          dispatch(
            setManageTransactionToastInfo({
              showToast: false,
              toastMessage: "",
              reject: false,
            })
          )
        }
        show={showToast}
        style={{
          position: "fixed",
          top: "10rem",
          right: "2rem",
          zIndex: "100",
          borderColor: reject ? "#F19937" : "#3BB54A",
        }}
        delay={3000}
        autohide
      >
        <Toast.Body className="success-toast-align">
          <div className="mr-2">
            {showToast ? (
              reject ? (
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  color="#F19937"
                  size="lg"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  color="#3BB54A"
                  size="lg"
                />
              )
            ) : (
              ""
            )}
          </div>
          <div
            style={{
              fontWeight: "500",
              fontSize: "14px",
              //lineHeight: "21px",
              color: reject ? "#F19937" : "#3BB54A",
            }}
          >
            <p
              style={{
                margin: "0px",
                padding: "0px",
                fontWeight: "500",
                color: reject ? "#F19937" : "#3BB54A",
              }}
            >
              {toastMessage}
            </p>
            <p
              style={{
                margin: "0px",
                padding: "0px",
                color: "#333333",
                fontSize: "12px",
              }}
            >
              {toastMessage2}
            </p>
            <p
              style={{
                margin: "0px",
                padding: "0px",
                color: "#333333",
                fontSize: "12px",
              }}
            >
              {toastMessage1}
            </p>
          </div>

          <div className="ml-2">
            {showToast ? (
              <FontAwesomeIcon
                icon={faTimesCircle}
                color="#000000"
                size="md"
                onClick={() =>
                  dispatch(
                    setManageTransactionToastInfo({
                      showToast: false,
                      toastMessage: "",
                      reject: false,
                    })
                  )
                }
              />
            ) : (
              ""
            )}
          </div>
        </Toast.Body>
      </Toast>
      <RouteLeavingGuard
        when={
          (!isSubmitting && dirty && !blockNavigation) ||
          (useBlockNavigationAlways && !blockNavigation)
        }
        navigate={(path) => history.push(path)}
        onRefresh={onRefresh}
      />
    </div>
  );
};

export default withRouter(ManageTransactionLayout);
